/** Navy-to-teal gradient used on the My Subscriptions banner and subscription dialog header. */
export const KBO_BANNER_GRADIENT =
    "linear-gradient(90deg, #1D2460 0%, #1E2F64 35%, #1F566F 70%, #1F7C86 100%)";
